<template>
  <!-- 合同代写 -->
  <div class="conmodwrite">
    <div class="w10f8"><cdwritemenu /></div>
    <div><cdwritreason /></div>
    <div class="w10f8"><cdwritobtawh /> </div>
    <div><cdwriserrelat /></div>
    <div class="w10f8"><cdwriteam /> </div>

  </div>
</template>

<script>
import cdwritemenu from "./child/cdwritemenu";//菜单banner
import cdwritreason from "./child/cdwritreason";//中间理由
import cdwritobtawh from "./child/cdwritobtawh"//你能获得什么
import cdwriserrelat from "./child/cdwriserrelat"//服务流程
import cdwriteam from "./child/cdwriteam"//服务团队&评价
export default {
  name: "conmodwrite",
  components: {
    cdwritemenu,
    cdwritreason,
    cdwritobtawh,
    cdwriserrelat,
    cdwriteam,
  },
  mounted(){
  }
};
</script>

<style lang="scss" scoped>
.conmodwrite {
  .w10f8 {
    width: 100%;
    background: #f8f8f8;
  }
}
</style>